import { FC, useCallback, useEffect, useRef, useState } from 'react';

import BundleCover from './BundleCover';
import BundleBadge from './BundleBadge';
import {
    BulkAddProductsToSelectionListResponse,
    BulkAddProductsToShoppingCartResponse,
    BundleOut
} from '../../store/api';
import { AppDispatch } from '../../store';
import { PriceTier } from '../../../models/PriceTier';
import { Orderlist } from '../../../models/OrderList';
import { BundleHeader } from './BundleHeader';
import { isEmptyProductFilters, useProductFilters } from '../filter/useProductFilters';
import { useTranslation } from 'react-i18next';

type Props = {
    readonly bundle: BundleOut & { price?: number };
    readonly orderlist?: Orderlist;
    readonly orderlists: ReadonlyArray<Orderlist>;
    readonly onAddBundleToList: (
        listId: string,
        priceTier: PriceTier,
        performChecks: boolean
    ) => Promise<BulkAddProductsToSelectionListResponse>;
    readonly onAddBundleToCart: (
        priceTier: PriceTier,
        performChecks: boolean
    ) => Promise<BulkAddProductsToShoppingCartResponse>;
    readonly onCreateNewListClicked?: (newListName: string) => void;
    readonly dispatch: AppDispatch;
};

const DetailHeader: FC<Props> = ({
    onAddBundleToList,
    onAddBundleToCart,
    bundle,
    orderlists,
    onCreateNewListClicked
}) => {
    const { t } = useTranslation();
    const coverRef = useRef<HTMLImageElement>(null);
    const [filtered, setFiltered] = useState(false);

    const { filters } = useProductFilters();
    const isBundleFiltered = useCallback(() => !isEmptyProductFilters(filters), [filters]);

    const badge = bundle.salesTag ? <BundleBadge bundle={bundle} /> : null;

    useEffect(() => {
        if (isBundleFiltered() && !filtered) {
            setFiltered(true);
        } else if (!isBundleFiltered() && filtered) {
            setFiltered(false);
        }
    }, [filtered, isBundleFiltered]);

    const description = t(`selectionList.groupedByItem.${bundle.bundleId}.description`, {
        defaultValue: bundle.description
    });

    return (
        <>
            <BundleHeader
                title={bundle.title}
                bundle={bundle}
                filtered={filtered}
                onAddBundleToList={onAddBundleToList}
                onAddBundleToCart={onAddBundleToCart}
                onCreateNewListClicked={onCreateNewListClicked}
                orderlists={orderlists}
            />

            <div>
                <div className="bndl-cover bndl-cover-detail fl-left">
                    <BundleCover bundle={bundle} ref={coverRef} />
                </div>
                <div className="description fl-left">
                    <div>{description}</div>
                    {badge}
                </div>
            </div>

            <div className="spacer">
                <h4>Included Titles</h4>
            </div>
        </>
    );
};

export default DetailHeader;
